export const environment = {
  baseUrl: '/api/bo',
};
